/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Sos_Fulfillment_StoppedInputs */

const en_queue_sos_fulfillment_stopped = /** @type {(inputs: Queue_Sos_Fulfillment_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales orders whose process stopped`)
};

/**
* | output |
* | --- |
* | "Sales orders whose process stopped" |
*
* @param {Queue_Sos_Fulfillment_StoppedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_sos_fulfillment_stopped = /** @type {((inputs?: Queue_Sos_Fulfillment_StoppedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Sos_Fulfillment_StoppedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_sos_fulfillment_stopped(inputs)
});